class generalHelper {
    
    constructor() {
        this.initAccordion();
        this.initIframeSizing();
        this.initAlert();
        this.initHomeVideoPause();
    }
    initAccordion() {
        Array.from(document.querySelectorAll('[data-accordion]')).forEach((el) => {
            el.querySelector('.expand-all').addEventListener('click', function(event) {

                event.preventDefault();
                $(el).find('.collapse').collapse('show');
                return false;
            });
        });
    }
    initIframeSizing() {
        Array.from(document.querySelectorAll('iframe')).forEach((iframe) => {
            iframe.width  = iframe.contentWindow.document.body.scrollWidth;
            iframe.height = iframe.contentWindow.document.body.scrollHeight;
        });
    }
    initAlert() {
        var bannerAlert = document.querySelector('#banner-alert');
        if(bannerAlert) {
            if(!window.app.cookies.get('alertClosed')) {
                bannerAlert.style.display = 'block';
            }
            document.querySelector('#banner-alert .close').addEventListener('click', function(event) {
                bannerAlert.style.display = 'none';
                window.app.cookies.set('alertClosed', true, 60 * 60);
            });
        }
    }
    initHomeVideoPause() {
        var pause = document.querySelector('#pauseLoop');
        var play = document.querySelector('#playLoop');
        var video = document.querySelector('#homeVideo');
        pause.addEventListener('click', function(event) {
            event.preventDefault();
            pause.style.display = 'none';
            play.style.display = 'block';
            video.pause();
            return false;
        });
        play.addEventListener('click', function(event) {
            event.preventDefault();
            pause.style.display = 'block';
            play.style.display = 'none';
            video.play();
            return false;
        });
    }
}
window.app.add('generalHelper', new generalHelper());